// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2TCZ8","icon":"style_icon__2GfAa"};